// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__2TLPB","white":"style_white__1RZYm","gray":"style_gray__1rfb_","containerInner":"style_containerInner__VERqo","logo":"style_logo__1akH6"};